<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-envelope"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">رسائل الحجز — {{ group?.name ?? '...' }}</h1>
        <p class="form-page-header__subtitle">
          خصص رسائل الحجز لهذه المجموعة. اترك أي حقل فارغاً لاستخدام رسالة نصوص الموقع الافتراضية.
        </p>
      </div>
    </div>

    <div class="container-fluid">
      <div v-if="loading" class="text-center py-5">
        <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;"></i>
      </div>

      <form v-else @submit.prevent="saveMessages()">
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-envelope"></i></div>
            <div>
              <span class="form-card__title">رسائل الحجز (اختياري)</span>
              <p class="form-card__subtitle">Reservation Messages (Optional)</p>
            </div>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">رسالة القبول (Accept Message)</label>
                  <Editor v-model="messages.accept_message" editorStyle="height: 180px" />
                  <small class="text-muted d-block mt-1">اترك هذا الحقل فارغاً لاستخدام الرسالة الافتراضية من نصوص الموقع.</small>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">رسالة الرفض (Reject Message)</label>
                  <Editor v-model="messages.reject_message" editorStyle="height: 180px" />
                  <small class="text-muted d-block mt-1">اترك هذا الحقل فارغاً لاستخدام الرسالة الافتراضية من نصوص الموقع.</small>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">رسالة قائمة الانتظار (Waiting List Message)</label>
                  <Editor v-model="messages.waiting_message" editorStyle="height: 180px" />
                  <small class="text-muted d-block mt-1">اترك هذا الحقل فارغاً لاستخدام الرسالة الافتراضية من نصوص الموقع.</small>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">رسالة بعد الإرسال (After Submit Message)</label>
                  <Editor v-model="messages.after_submit_message" editorStyle="height: 180px" />
                  <small class="text-muted d-block mt-1">اترك هذا الحقل فارغاً لاستخدام الرسالة الافتراضية من نصوص الموقع.</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" :disabled="saving">
            <i class="pi pi-spin pi-spinner-dotted" v-if="saving"></i>
            <i class="pi pi-check" v-else></i>
            {{ saving ? 'جاري الحفظ...' : 'حفظ الرسائل' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Editor from 'primevue/editor';
import Breadcrumb from '@/components/global/breadcrumb.vue';

export default {
  name: 'GradeGroupMessages',
  components: { Editor, Breadcrumb },

  data() {
    return {
      group: null,
      loading: true,
      saving: false,
      messages: {
        accept_message: '',
        reject_message: '',
        waiting_message: '',
        after_submit_message: '',
      },
    };
  },

  computed: {
    gradeSlug() { return this.$route.params.gradeSlug; },
    groupId() { return this.$route.params.groupId; },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'مجموعات الطلاب', path: `/grades/${this.gradeSlug}/groups` },
        { name: this.group?.name ?? 'المجموعة', path: `/grades/${this.gradeSlug}/groups/${this.groupId}` },
        { name: 'رسائل الحجز', path: `/grades/${this.gradeSlug}/groups/${this.groupId}/messages` },
      ];
    },
  },

  methods: {
    async fetchGroup() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/student-groups/${this.groupId}`);
        this.group = data.data.group;
        this.messages = {
          accept_message: this.group.accept_message ?? '',
          reject_message: this.group.reject_message ?? '',
          waiting_message: this.group.waiting_message ?? '',
          after_submit_message: this.group.after_submit_message ?? '',
        };
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ أثناء تحميل بيانات المجموعة', 'error');
      } finally {
        this.loading = false;
      }
    },

    async saveMessages() {
      this.saving = true;
      try {
        const { data } = await axios.put(`/student-groups/${this.groupId}`, {
          name: this.group.name,
          ...this.messages,
        });
        this.group = data.data;
        Swal.fire({ position: 'center', icon: 'success', title: 'تم حفظ رسائل الحجز بنجاح' });
      } catch (error) {
        Swal.fire({ position: 'center', icon: 'error', title: error.response?.data?.message || 'حدث خطأ أثناء الحفظ' });
      } finally {
        this.saving = false;
      }
    },
  },

  mounted() {
    this.fetchGroup();
  },
};
</script>

<style scoped>
</style>
